import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProductsRoutingModule } from './products-routing.module';
import { ProductsComponent } from './products.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MatExpansionModule } from '@angular/material/expansion';
import { CustomFlexLayoutModule } from 'src/app/flex-layout/custom-flex-layout.module';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { MatSliderModule } from '@angular/material/slider';
import { MatButtonModule } from '@angular/material/button';
import { NouisliderModule } from 'ng2-nouislider';
import { MatCardModule } from '@angular/material/card';
import { FitersComponent } from './fiters/fiters.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { SortComponent } from './sort/sort.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DirectiveModule } from 'src/app/shared/utils/directive/directive.module';
import { ImageLazyLoadingModule } from 'src/app/theme/image-lazy-loading/image-lazy-loading.module';
import { PipesModule } from 'src/app/theme/pipes/pipes.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { ProductLayoutModule } from 'src/app/theme/product-layout/product-layout.module';
import { BreadcrumbModule } from 'src/app/theme/breadcrumb/breadcrumb.module';
import { SubCategoryListModule } from 'src/app/theme/sub-category-list/sub-category-list.module';

@NgModule({
    declarations: [ProductsComponent,
        FitersComponent,
        SortComponent,
    ],
    imports: [
        CommonModule,
        ProductsRoutingModule,
        MatMenuModule,
        MatIconModule,
        PipesModule,
        InfiniteScrollModule,
        MatExpansionModule,
        CustomFlexLayoutModule,
        MatCheckboxModule,
        NgxPaginationModule,
        InfiniteScrollModule,
        MatSnackBarModule,
        ReactiveFormsModule,
        FormsModule,
        MatInputModule,
        MatChipsModule,
        MatMenuModule,
        MatSliderModule,
        MatButtonModule,
        NouisliderModule,
        MatCardModule,
        MatToolbarModule,
        MatSidenavModule,
        MatListModule,
        MatBottomSheetModule,
        MatRadioModule,
        ImageLazyLoadingModule,
        PipesModule,
        MatProgressSpinnerModule,
        DirectiveModule,
        ProductLayoutModule,
        BreadcrumbModule,
        SubCategoryListModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ProductsModule { }
